import React from 'react'
import Grid from '@material-ui/core/Grid'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { CustomLink } from './styles'
import { getTrackingLinks, getSalesforceOrderTrackingLinks } from '../../../../../common/helpers'

const ShipMethodsToIgnoreTrackingNumbers = [
  'USPS First Class Mail (Postage Paid) - Flat'
]

export default (props) => {
  const { shipment, order } = props

  dayjs.extend(utc)

  return (
    <Grid container spacing={0}>
      <Grid className="text" item xs={12}>
        {order ? <div>{order.totalItems} Item{parseInt(order.totalItems, 10) > 1 ? 's' : ''}</div> : null}
        <div>
          {shipment.carrier.trackingNumbers ? shipment.carrier.trackingNumbers.map((t, index) => {
            if (ShipMethodsToIgnoreTrackingNumbers.includes(shipment.carrier.via)) return
            const item = order.origin === 'Salesforce'
              ? getSalesforceOrderTrackingLinks(shipment.carrier.via, t)
              : getTrackingLinks(shipment.carrier.preferenceCode, t)
            if (item.link) {
              return <div><CustomLink target="_blank" href={item.link} key={`tracking_number_${index}`}>{item.number}</CustomLink></div>
            }
            return <div key={`tracking_number_${index}`}>{item.number}</div>
          }) : null}
        </div>
        <div>{shipment.carrier.via}</div>
        <div>Processed date: </div>
        <div>{dayjs.utc(shipment.shipDate).format('YYYY-MM-DD')}</div>
      </Grid>
    </Grid>
  )
}
